import { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";

const TopCitis = () => {
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const options = {
      chart: {
        type: "area",
        height: 350,
      },
      series: [
        {
          name: "Loads",
          data: [43, 38, 45, 60, 25, 35, 40],
        },
      ],
      stroke: {
        curve: "stepline",
      },

      grid: {
        show: true,
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#a45ff8"],
      xaxis: {
        categories: [
          "New York",
          "Los Angeles",
          "Chicago",
          "Houston",
          "Phoenix",
          "Fontana",
          "California",
        ],
      },
    };

    if (chartRef.current) {
      const chart = new ApexCharts(chartRef.current, options);
      chart.render();

      // Cleanup on unmount
      return () => chart.destroy();
    }
  }, []);

  return (
    <div className="bg-white  rounded border">
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <h5 className="text-lg font-semibold text-gray-600">Top Cities</h5>
        {/* <div className="relative inline-block text-left">
          <button
            className="p-1 text-gray-600 hover:text-gray-800"
            type="button"
          >
            <i className="fa fa-bars"></i>
          </button>
          <div className="hidden absolute right-0 mt-2 w-40 bg-white border rounded shadow-md z-10">
            <a
              href="#"
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Select All
            </a>
            <a
              href="#"
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Refresh
            </a>
            <a
              href="#"
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Share
            </a>
          </div>
        </div> */}
      </div>

      <div className="p-4">
        <div id="topcities" ref={chartRef}></div>
      </div>
    </div>
  );
};

export default TopCitis;
